export default __webpack_public_path__ + "static/heroIntro-180020f0416c28a952c40e9ea1215b87.mp4";